module.exports = __webpack_public_path__ + "img/logo-mgb.e0af7755.png";